/**
 * Canonical placement label format used across chart, interpretation, and badges.
 * Ensures visual-textual connection: same wording everywhere.
 * Example: "Sun — Libra — 5th House"
 */
export function formatPlacementLabel(placement) {
  if (!placement) return '';
  const name = placement.name || placement.nameFi || placement.key || '';
  const sign = placement.sign || '';
  const house = placement.house;
  const housePart = Number.isFinite(Number(house)) ? ` — ${ordinalHouse(house)} House` : '';
  return `${name} — ${sign}${housePart}`.trim();
}

function ordinalHouse(value) {
  const house = Number(value);
  if (house === 1) return '1st';
  if (house === 2) return '2nd';
  if (house === 3) return '3rd';
  return `${house}th`;
}
